export function round(number, decimals) {
    // the technique here is called scaling to avoid all the crazy floating point issues
    var factor = Math.pow(10, decimals);
    return Math.round(number * factor) / factor;
}

// Standard functions:
// to_i ... parseInt(string)

export function formatDE(number, decimals=2) {
    // the technique here is called scaling to avoid all the crazy floating point issues
    var factor = Math.pow(10, decimals);
    var roundedNr= Math.round(number * factor) / factor;
    var stringRep=roundedNr.toLocaleString("de");
    if (stringRep.endsWith(",00"))
        return stringRep.replace(",00", "");
    return stringRep;
}
